import React, { useState, useEffect } from 'react';

import Row from 'react-bootstrap/Row';
import Plot from './components/Plot';
import PatternTable from './components/PatternTable';
import Container from 'react-bootstrap/Container';

function App() {
  
  const [selectedDataRows, setSelectedDataRows] = useState([]);
  

  const defaultValues = [{
    CommunicationPattern: "The domestic robot detaches its memory card to physically prevent the camera, microphone, and internet connection from functioning.",
    Q:  "CP1",
    Functionality: "all"
    },
    {CommunicationPattern: "The domestic robot blocks its own movement to physically prevent the camera from recording.",
    Q:  "CP6",
    Functionality: "camera"
    },
    {CommunicationPattern: "The domestic robot crosses its arms to signal that it is disconnected from the internet.",
    Q:  "CP14",
    Functionality: "connectivity"
    },
    {CommunicationPattern: "The domestic robot goes to its docking station to physically prevent the camera, microphone, and internet connection from functioning.",
    Q:  "CP39",
    Functionality: "all"
    },
    {CommunicationPattern: "The domestic robot has a light band attached to signal that it is disconnected from the internet.",
    Q:  "CP41",
    Functionality: "connectivity"
    },
    {CommunicationPattern: "The domestic robot puts a physical cover over its camera to physically prevent the camera from recording.",
    Q:  "CP51",
    Functionality: "camera"
    },
    {CommunicationPattern: "The domestic robot removes the microphone’s cable to physically prevent the microphone from recording.",
    Q:  "CP56",
    Functionality: "microphone"
    },
    {CommunicationPattern: "The domestic robot uses a physical switch to physically prevent the camera from recording.",
    Q:  "CP69",
    Functionality: "camera"
    },
    {CommunicationPattern: "The domestic robot uses a physical switch to physically prevent the internet connection.",
    Q:  "CP70",
    Functionality: "connectivity"
    },
    ]

  const [dataTable, setDataTable] = useState(defaultValues);

  const handleDataChange = (data) => {
    // Update selectedDataRows in App.js whenever data changes in Test.js
    console.log("changeeees", data)

    if (Object.keys(data).length !== 0) {
      setSelectedDataRows(data);
    }
  };

   useEffect(() => {
    // This code will run whenever selectedDataRows changes
    // setDataTable(selectedDataRows)
    // console.log("daten?", selectedDataRows)

   if (Object.keys(selectedDataRows).length !== 0) {
    setDataTable(selectedDataRows);
  }



  }, [selectedDataRows ]); // Specify selectedDataRows as a dependency

  const column = [
    {
      heading: 'ID',
      value: 'Q'
    },
    {
      heading: 'Pattern',
      value: 'CommunicationPattern'
    },
    {
      heading: 'Functionality',
      value: 'Functionality'
    },
  ];

  return (
    <div className="">
    
      <div className="page">
        <h2>Communication Pattern Finder</h2>
        <p className="advice">You can manipulate the lower and upper limits of the bars and move them along the axis.</p>
        <Plot onDataChange={handleDataChange}/>
        </div>
      <div className="">
        <div className="patternTable full">
          <h3>{Object.keys(dataTable).length} patterns match your criteria:</h3>
          <Container fluid="md">
            <PatternTable data={dataTable} columns={column} />
          </Container>
      </div>
      </div>
    </div>
  );
};

export default App;